import React from 'react';
import PropTypes from 'prop-types';
import Step from './Step.jsx';
import styles from './HorizontalStepper.css';
import classnames from 'classnames';

class HorizontalStepper extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentStep: 0
    };
  }

  async navigate(toStep) {
    let {onNavigate} = this.props;
    let {currentStep} = this.state;

    this.setState({currentStep: toStep});

    await onNavigate(toStep, currentStep);
  }

  async submit(event) {
    let {onSubmit} = this.props;

    await onSubmit(event);
  }

  async cancel() {
    let {onCancel} = this.props;

    await onCancel();
  }

  render() {
    let {
      children,
      submitText
    } = this.props;

    const numSteps = React.Children.count(children);
    const onFinalStep = this.state.currentStep === (numSteps - 1);
    const step = React.Children.toArray(children)[this.state.currentStep];

    return (
      <div>
        <div className={styles.stepHeaders}>
          {this.renderStepTitles()}
        </div>
        {
          React.cloneElement(step, {
            submitText: onFinalStep ? this.props.submitText : "Next Step",
            hideBackButton: this.state.currentStep === 0,
            onBack: async () => {
              if (this.state.currentStep > 0) {
                await step.props.onBack();
                await this.navigate(this.state.currentStep - 1);
              }
            },
            onNext: async e => {
              await step.props.onNext(e);
              if (onFinalStep) {
                await this.submit(e);
              }
              else {
                await this.navigate(this.state.currentStep + 1);
              }
            },
            onCancel: async () => {
              await step.props.onCancel();
              await this.cancel();
            }
          })
        }
      </div>
    );
  }

  renderStepTitles() {
    let {
      children
    } = this.props;

    let {
      currentStep
    } = this.state;

    return React.Children.map(children, (child, idx) => (
      <div className={classnames(styles.stepHeader, currentStep >= idx && styles.currentStep)} key={idx}>
        <hr />
        <div className={styles.stepNumber}>
          {currentStep > idx ? <i className="icon-check-mark"></i> : idx + 1}
        </div>
        <div className={styles.stepTitle}>
          {child.props.title}
        </div>
      </div>
    ));
  }
}

HorizontalStepper.propTypes = {
  children: function (props, propName, componentName) {
    const prop = props[propName];

    let error = null;
    React.Children.forEach(prop, function (child) {
      if (child.type !== Step) {
        error = new Error('`' + componentName + '` children should be of type `Step`.');
      }
    });
    return error;
  },
  submitText: PropTypes.string,
  onNavigate: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func
};

HorizontalStepper.defaultProps = {
  submitText: "Finish",
  onNavigate: () => {},
  onSubmit: () => {},
  onCancel: () => {}
};

export default HorizontalStepper;